export default "__VITE_ASSET__BIkoJ1sm__"